import { ProductType } from '../../hooks/useProducts';
import { useTailwindBreakpoint } from '../../hooks/useTailwindBreakpoint';
import { TradeCharts } from './TradeCharts/TradeCharts';
import { TradeFavorites } from './TradeFavorites/TradeFavorites';
import { TradeFooter } from './TradeFooter/TradeFooter';
import { TradeForm } from './TradeForm';
import { TradeHeader } from './TradeHeader/TradeHeader';

type TradePageDesktopProps = {
  product: ProductType;
};

export function TradePageDesktop({ product }: TradePageDesktopProps) {
  const is2xl = useTailwindBreakpoint('2xl');

  return (
    <div className="flex grow flex-col gap-1">
      {!is2xl && (
        <>
          <TradeFavorites />
          <TradeHeader product={product} />
        </>
      )}
      <div className="m-4 flex grow flex-col items-stretch gap-1 sm:m-0 lg:flex-row">
        <div className="flex w-full min-w-0 flex-1 flex-col gap-1">
          <div className="flex flex-col">
            <TradeCharts product={product} />
          </div>
          <div className="h-full min-h-0 grow bg-backgroundBase">
            <TradeFooter product={product} />
          </div>
        </div>
        <TradeForm product={product} />
      </div>
    </div>
  );
}
